class functionLibrary {
    constructor() {
    }
  
    changeBodyColour(object, colour, THREE, gsap) {
        if(gsap) {
            let initial = new THREE.Color(object.material.color.getHex());
            const value = new THREE.Color(`#${colour}`)
            const changeColorAnim = gsap.timeline(
                {
                    onUpdate:function () {
                        object.material.color = initial;
                    },
                }
            );
            changeColorAnim
            .to(initial,
                {
                    r: value.r,
                    g: value.g,
                    b: value.b,
                    duration: .5
                },
                "<"
            )
        }else {
            object.material.color = new THREE.Color(`#${colour}`)
        }
    }
  
    changeBodyColourMatName(material, colour, THREE, gsap) {
        if(gsap) {
            let initial = new THREE.Color(material.color.getHex());
            const value = new THREE.Color(`${colour}`)
            const changeColorAnim = gsap.timeline(
                {
                    onUpdate:function () {
                        material.color = initial;
                    },
                }
            );
            changeColorAnim
            .to(initial,
                {
                    r: value.r,
                    g: value.g,
                    b: value.b,
                    duration: .5
                },
                "<"
            )
        }else {
            material.color = new THREE.Color(`#${colour}`)
        }
    }
  
    xRayAnimation(materials, THREE, gsap, xRayOn) {

        for (let index = 0; index < materials.length; index++) {
            const material = materials[index];
            
            if(gsap) {
                let initial = material.opacity;
                let value
                if(xRayOn) {
                    value = 0.1
                }else {
                    value = 1
                }
                material.transparent = true
                const changeColorAnim = gsap.timeline(
                    {
                    }
                );
                changeColorAnim
                .to(material,
                    {
                        opacity: value,
                        duration: 1.5
                    },
                    "<"
                )
            }else {
                material.transparent = true
                material.opacity = 0.2
            }
        }
    }

}
  
const instance = new functionLibrary();
export { instance as functionLibrary };